import { KitchenShiftType, RosterType } from 'models/kitchen-roster.model';

export const transformRoster = (roster: KitchenShiftType[]) => {
  const result: {
    [deptName: string]: {
      department: string;
      department_id: string;
      morning: string[];
      afternoon: string[];
      night: string[];
    };
  } = {};

  const data = roster?.[0];
  const shiftKeys = ['morning', 'afternoon', 'night'] as const;
  type ShiftKey = (typeof shiftKeys)[number];

  for (const shift in data.shifts) {
    if (shiftKeys.includes(shift as ShiftKey)) {
      const shiftKey = shift as ShiftKey;
      const departments = data.shifts[shiftKey] ?? [];

      for (const dept of departments) {
        const deptName = dept.department;

        if (!result[deptName]) {
          result[deptName] = {
            department: deptName,
            department_id: dept.department_id,
            morning: [],
            afternoon: [],
            night: []
          };
        }

        for (const staff of dept.staff) {
          result[deptName][shiftKey].push(staff.staff_number);
        }
      }
    }
  }

  return Object.values(result);
};

export const transformShifts = (data: RosterType[], date: string) => {
  const result: {
    shift_date: string;
    shift_name: string;
    department_id: string;
    staff_numbers: string[];
  }[] = [];

  data.forEach((department) => {
    const department_id = department?.department_id as string;

    ['morning', 'afternoon', 'night'].forEach((shiftName) => {
      const staffNumbers = department[shiftName as keyof RosterType] || [];
      if (staffNumbers && staffNumbers.length > 0) {
        result.push({
          shift_date: date as string,
          shift_name: shiftName,
          department_id,
          staff_numbers: staffNumbers as string[]
        });
      }
    });
  });

  return result;
};
